export default __webpack_public_path__ + "static/media/all_logo.f5bd5244.svg";